import { render, staticRenderFns } from "./Pricing-cn.vue?vue&type=template&id=d4ca1286&scoped=true&"
import script from "./Pricing-cn.vue?vue&type=script&lang=js&"
export * from "./Pricing-cn.vue?vue&type=script&lang=js&"
import style0 from "./Pricing-cn.vue?vue&type=style&index=0&id=d4ca1286&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ca1286",
  null
  
)

export default component.exports